export default __webpack_public_path__ + "static/media/cart.18f8456c.png";